module.exports = new __parcel__URL__("shop_machines_linkins_armory.fbbed815.png").toString();